import { Config, AuthHeader } from "../helpers/Config";

export const UserService = {
    /**
     * [LOGIN]
     * @param {object} data
     * @param {string} data.login
     * @param {string} data.password
     */
    Login(data) {

        var requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        }

        return UserService.Common.Fetch(Config.service.user.login, requestOptions);

    },
    /**
    * [LOGOUT]
    */
    Logout() {
        localStorage.removeItem('user');
        localStorage.removeItem('userActiveAccount');
    },
    /**
    * [AUTHENTICATED]
    */
    Authenticated() {

        var requestOptions = {
            method: 'POST',
            headers: AuthHeader()
        }

        return fetch(Config.service.user.authenticated, requestOptions)
            .then(response => {

                if (response.ok) {
                    return true;
                } else {
                    return false;
                }

            }).catch(function () {
                return false;
            });
    },
    /**
    * [ACCOUNT]
    */
    Account: {
        /**
         * [DETAIL]
         * @param {object} data
         * @param {int} data.login
         * @param {boolean} data.onlyInfo
         */
        Detail(data) {

            var requestOptions = {
                method: 'POST',
                headers: AuthHeader(),
                body: JSON.stringify(data)
            }

            return UserService.Common.Fetch(Config.service.user.account.detail, requestOptions);

        },
        /**
        * [LIST]
        */
        List(filter) {

            var requestOptions = {
                method: 'POST',
                headers: AuthHeader(),
                body: JSON.stringify({ filter: filter })
            }

            return UserService.Common.Fetch(Config.service.user.account.list, requestOptions);

        },
        /**
        * [ALL]
        */
        All() {

            var requestOptions = {
                method: 'GET',
                headers: AuthHeader()
            }

            return UserService.Common.Fetch(Config.service.user.account.all, requestOptions);
        },
        WhiteList() {

            var requestOptions = {
                method: 'GET',
                headers: AuthHeader()
            }
    
            return UserService.Common.Fetch(Config.service.user.addressWhiteList, requestOptions);
        },
        AddAddressWhiteList(data) {
    
            var requestOptions = {
                method: 'POST',
                headers: AuthHeader(),
                body: JSON.stringify(data)
            }
    
            return UserService.Common.Fetch(Config.service.user.addAddressWhiteList, requestOptions);
        },
        /**
        * [HISTORY]
        * @param {object} data
        * @param {int} data.login
        * @param {Date} data.startDate
        * @param {Date} data.endDate
        */
        History(data) {

            var requestOptions = {
                method: 'POST',
                headers: AuthHeader(),
                body: JSON.stringify(data)
            }

            return UserService.Common.Fetch(Config.service.user.account.history, requestOptions);
        }
    },
    /**
    * [BANK_ACCOUNT]
    */
    BankAccounts() {

        var requestOptions = {
            method: 'GET',
            headers: AuthHeader()
        }

        return UserService.Common.Fetch(Config.service.user.bankAccounts, requestOptions);
    },
    /**
    * [CUSTOMER_BANK_ACCOUNT_LIST]
    * @param {object} data
    * @param {int} data.login
    */
    CustomerBankAccountList(data) {

        var requestOptions = {
            method: 'POST',
            headers: AuthHeader(),
            body: JSON.stringify(data)
        }

        return UserService.Common.Fetch(Config.service.user.customerBankAccountList, requestOptions);
    },
    /**
    * [CUSTOMER_BANK_ACCOUNT_ADD]
    * @param {object} data
    * @param {int} data.login
    * @param {string} data.accountTitle
    * @param {string} data.accountNumber
    * @param {string} data.bankName
    * @param {string} data.iban
    * @param {string} data.swift
    * @param {string} data.accountCurrency
    */
    CustomerBankAccountAdd(data) {

        var requestOptions = {
            method: 'POST',
            headers: AuthHeader(),
            body: JSON.stringify(data)
        }

        return UserService.Common.Fetch(Config.service.user.customerBankAccountAdd, requestOptions);
    },
    /**
    * [CAMPAIGNS]
    */
    Campaigns() {

        var requestOptions = {
            method: 'GET',
            headers: AuthHeader()
        }

        return UserService.Common.Fetch(Config.service.user.campaigns, requestOptions);
    },   
    /**
     * [COMMON]
     * @function Fetch
     */
    Common: {
        Fetch(url, requestOptions) {

            return fetch(url, requestOptions)
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    }
                    else if (response.status === 401) {

                        UserService.Logout();

                        window.location.reload();

                    } else {
                        throw new Error();
                    }
                }).then((json) => {
                    return json;
                }).catch(function () {
                    return false;
                });

        }
    }
}





